
export default class FiltroGerenciarTransportadora {
    constructor() {
        this.Endereco = undefined;
        this.NomeTransportadora = undefined;
        this.NomeReduzido = undefined;
        this.Bairro = undefined;
        this.TransportadoraId
        this.Cep = undefined;
        this.EstadoId = undefined;
        this.CidadeId = undefined;
        this.UnidadeId = undefined;
        this.Complemento = undefined;
        this.Cnpj = undefined;
        this.CodigoExterno = undefined;
    }
}